// TODO: add designs.
export const AppStartupError = () => {
  window.location.replace(window.location.origin);
  return <>An error occured.</>;
};
